export default "/images/0e51223532a802ed83e3c7a00b6baf48.avif";